// extracted by mini-css-extract-plugin
export default {"item":"Options_item__tmHHU","options":"Options_options__6l3sz"};